import React from "react";

export default function RightMigration() {
  return (
    <img
      src="/assets/odontogram/arrow-right-1.svg"
      alt="arrow-right"
      width="50"
      height="15"
    ></img>
  );
}
